import React from 'react';

import Content from '@components/Dashboard/AdminPanel/ChangeCredential';

const ChangeCredential: React.FC = () => {
  return <Content />;
};

export default ChangeCredential;
